import { connect } from 'react-redux';
import { markCardPrimary } from '../../../../actions/markCardPrimary';
import {
  selectMarkCardPrimaryFailed,
  selectMarkCardPrimaryLoading,
  selectMarkCardPrimaryState,
  selectViewMode,
} from '../../../../selectors/appState';
import { selectMarkCardPrimaryCardId } from '../../../../selectors/creditCard';
import { selectMobileType } from '../../../../selectors/deviceType';
import { IStoreState } from '../../../../types/StoreState';
import { MarkCardPrimaryController } from './controller';

export const MarkCardPrimaryConnect = connect(
  (state: IStoreState) => ({
    viewMode: selectViewMode(state),
    isMarkCardPrimaryLoading: selectMarkCardPrimaryLoading(state),
    desiredPrimaryCardId: selectMarkCardPrimaryCardId(state),
    isMarkCardFailed: selectMarkCardPrimaryFailed(state),
    mobile: selectMobileType(state),
    markCardPrimaryState: selectMarkCardPrimaryState(state),
  }),
  {
    markCardPrimary,
  },
)(MarkCardPrimaryController);
